(()=>{
  const shell=document.querySelector('[data-it-ring-shell]');
  if(!shell)return;

  document.body.classList.add('it-ring-active');

  const shellSection=shell.closest('.shopify-section');
  const builderRoot=shellSection?.nextElementSibling;
  if(!builderRoot)return;

  const norm=v=>(v||'').replace(/\s+/g,' ').trim().toLowerCase();
  const params=()=>new URLSearchParams(location.search);
  const ctx=()=>({stage:params().get('stage')||'',detail:params().get('viewDetailsId')||''});
  const review=c=>{const s=norm(c.stage);return s.includes('complete')||s.includes('review')||s.includes('ring size')};
  const push=(event,extra={})=>{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event,...extra,page_path:location.pathname+location.search})};

  const exact=(el,from,to)=>{
    if(!el||norm(el.innerText||el.textContent)!==norm(from))return false;
    const w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT);
    while(w.nextNode()){
      const n=w.currentNode;
      if(norm(n.nodeValue)===norm(from)){
        n.nodeValue=n.nodeValue.replace(n.nodeValue.trim(),to);
        return true;
      }
    }
    if(!el.querySelector('svg,img,picture')){el.textContent=to;return true}
    return false;
  };

  const whatsapp=()=>document.querySelectorAll('[data-it-whatsapp]').forEach(a=>{
    a.href='https://wa.me/447538174795?text='+encodeURIComponent('Hello Imperial Time, I’d like help with my ring design. Current page: '+location.href);
  });

  const updateShell=()=>{
    const c=ctx(),active=!!c.stage||!!c.detail;
    const intro=shell.querySelector('[data-it-ring-intro]');
    const assist=shell.querySelector('[data-it-ring-assist]');
    if(intro)intro.hidden=active;
    if(assist)assist.hidden=!active;

    const title=shell.querySelector('[data-it-assist-title]');
    const copy=shell.querySelector('[data-it-assist-copy]');
    const s=norm(c.stage);
    if(title&&copy){
      if(review(c)){
        title.textContent='Finalising your ring';
        copy.textContent='Choose from the available region and ring-size options, then continue with the complete ring.';
      }else if(s.includes('setting')){
        title.textContent='Choosing your setting';
        copy.textContent='Compare ring style, metal and setting price. Your selected diamond remains attached.';
      }else if(c.detail){
        title.textContent='Reviewing your diamond';
        copy.textContent='Review the stone media, measurements, grading details and certificate information where supplied.';
      }else{
        title.textContent='Choosing your diamond';
        copy.textContent='Start with shape, carat and budget, then refine colour, clarity, cut and advanced grading factors.';
      }
    }
  };

  const enhance=()=>{
    const c=ctx();
    builderRoot.querySelectorAll('button,a,[role="button"]').forEach(el=>{
      let label=norm(el.innerText||el.textContent);
      if(label==='select setting'){exact(el,'Select Setting','Select This Setting');label='select this setting'}
      if(label==='select diamond'){exact(el,'Select diamond','Select This Diamond');label='select this diamond'}
      if(label==='select this setting'){el.dataset.itNativeAction='setting_select';el.setAttribute('aria-label','Select This Setting')}
      if(label==='select this diamond'){el.dataset.itNativeAction='diamond_select';el.setAttribute('aria-label','Select This Diamond')}
      if(label==='advanced filters')el.dataset.itNativeAction='diamond_filters_open';
      if(label==='save this design'||label==='email me this ring')el.dataset.itNativeAction='save_design_open';
      if(review(c)&&['add to cart','add ring to cart','add complete ring to cart'].includes(label)){
        if(label!=='add complete ring to cart')exact(el,el.innerText||el.textContent,'Add Complete Ring to Cart');
        el.dataset.itNativeAction='add_complete_ring_to_cart';
        el.classList.add('it-nivoda-final-reward');
      }
    });
  };

  let guideStage='';
  const guideKey=()=>{
    const c=ctx(),s=norm(c.stage);
    if(review(c))return 'review';
    if(s.includes('setting'))return 'setting';
    if(s.includes('diamond')&&c.detail)return 'detail';
    if(s.includes('diamond'))return 'diamond';
    if(c.detail)return 'detail';
    return 'start';
  };

  const updateGuides=(force=false)=>{
    const key=guideKey();
    if(!force&&key===guideStage)return;
    guideStage=key;
    const education=document.querySelector('[data-it-ring-education]');
    const heading=document.querySelector('[data-it-guide-heading]');
    const intro=document.querySelector('[data-it-guide-intro]');

    if(education){
      education.classList.toggle('is-stage-active',key!=='start');
      education.classList.toggle('is-compact',key==='review'||key==='detail');
      education.dataset.itStage=key;
    }

    if(heading&&intro){
      if(key==='diamond'){
        heading.textContent='Diamond Buying Guidance';
        intro.textContent='Use the 4Cs and grading-report check below to refine your shortlist without interrupting your live diamond search.';
      }else if(key==='setting'){
        heading.textContent='Ring Setting & Metal Guidance';
        intro.textContent='Compare gold purity, metal colour, platinum and setting styles while the builder keeps the available options tied to your selected design.';
      }else{
        heading.textContent='Expert Guidance for Choosing Your Diamond and Ring Setting';
        intro.textContent='The ring builder above shows current diamonds, prices, compatible settings and available ring sizes. Open the guide that matches the decision you are making now.';
      }
    }

    document.querySelectorAll('[data-it-guide]').forEach(g=>{
      const match=g.dataset.itGuide===key;
      g.classList.toggle('is-priority',match);
      if(key==='diamond'||key==='setting')g.open=match;
      else g.open=false;
    });
  };

  const updateReviewPanel=()=>{
    const panel=document.querySelector('[data-it-review-panel]');
    if(!panel)return;
    panel.hidden=!review(ctx());
  };

  const sync=()=>{
    updateShell();
    enhance();
    updateGuides();
    updateReviewPanel();
    whatsapp();
  };

  updateGuides(true);
  sync();
  push('builder_view',{builder_route:'design-your-ring'});

  document.addEventListener('click',e=>{
    const t=e.target.closest('[data-it-event]');
    if(t)push(t.dataset.itEvent,{link_url:t.href||'',stage:ctx().stage});
    const n=e.target.closest('[data-it-native-action]');
    if(n)push(n.dataset.itNativeAction,{link_url:n.href||'',stage:ctx().stage});
    if(e.target.closest('[data-it-size-open]'))shell.querySelector('[data-it-size-dialog]')?.showModal();
    if(e.target.closest('[data-it-size-close]'))shell.querySelector('[data-it-size-dialog]')?.close();
  });

  document.addEventListener('toggle',e=>{
    const guide=e.target.closest?.('[data-it-guide]');
    if(guide&&e.target===guide)push('ring_guide_toggle',{guide:guide.dataset.itGuide,state:guide.open?'open':'closed',stage:ctx().stage});
  },true);

  let last=location.href,queued=false;
  new MutationObserver(()=>{
    if(queued)return;
    queued=true;
    requestAnimationFrame(()=>{
      queued=false;
      if(location.href!==last){
        const before=last;
        last=location.href;
        guideStage='';
        if(review(ctx())&&!norm(before).includes('complete'))push('review_view',{builder_route:'design-your-ring'});
      }
      sync();
    });
  }).observe(builderRoot,{subtree:true,childList:true});

  window.addEventListener('popstate',()=>{guideStage='';updateGuides(true);sync()});
})();